import { createSelector } from 'reselect';

function prepareUsers(state) {
  if(state.users!=null) return state.users.map((user)=> ({
      value: user.id,
      text: user.firstname+' '+user.lastname
    }));
}

const getAllPropsSelector = (state) => {
  return {
    users: prepareUsers(state),
    projects: state.projectContainer.projects,
    projectStates: state.projectStates,
    project: state.projectContainer.project,
    errors: state.projectContainer.errors,
    stats: state.projectContainer.stats,
    loading: (state.ajaxCallsInProgress>0)
  };
};

export default getAllPropsSelector;


/** WEBPACK FOOTER **
 ** ./src/container/ProjectContainer/selectors.js
 **/